import { useGetCustomerGuests } from 'api-hooks/customer';
import { Input } from 'baseui/input';
import { Pagination, SIZE } from 'baseui/pagination';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody, DrawerFooter } from 'components/common/drawer/styles';
import EmptyView from 'components/common/empty-view';
import LoadingComponent from 'components/common/loading';
import Separator from 'components/common/separator';
import CustomFormControl from 'components/elements/custom-form-control';
import { FooterDivider } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';

import GuestCard from './guest-card';

interface Props {
  customerId: string;
  onClose: () => void;
}

export default function ListGuestPanel(props: Props) {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(1);
  const [query, setQuery] = React.useState<string | undefined>();
  const { data, isFetching } = useGetCustomerGuests({
    id: props.customerId,
    params: { page, q: query },
  });
  const onQueryChange = useDebouncedCallback(
    (event) => {
      setQuery(event?.target?.value || '');
    },
    800,
    { trailing: true },
  );

  return (
    <>
      <DrawerHeader
        title={t('customer:list_guest')}
        onClose={props.onClose}
        $style={{ backgroundColor: 'white' }}
      />
      <DrawerBody>
        <CustomFormControl label={t('common:search').toString()}>
          <Input
            placeholder={t('customer:search_guest')}
            overrides={{
              Input: {
                style: {
                  paddingTop: '2px',
                  paddingBottom: '2px',
                },
              },
            }}
            onChange={onQueryChange}
          />
        </CustomFormControl>
        {isFetching ? (
          <LoadingComponent />
        ) : (
          <>
            {data?.data.length ? (
              (data?.data || []).map((item) => (
                <React.Fragment key={item.id}>
                  <GuestCard onDismiss={props.onClose} guest={item} />
                  <Separator gap={16} />
                </React.Fragment>
              ))
            ) : (
              <EmptyView />
            )}
            <FooterDivider />
            {data?.meta && (
              <DrawerFooter $style={{ justifyContent: 'center' }}>
                <Pagination
                  size={SIZE.mini}
                  overrides={{
                    MaxLabel: {
                      style: {
                        fontSize: '12px',
                      },
                    },
                    Select: {
                      props: {
                        overrides: {
                          Popover: {
                            props: {
                              overrides: {
                                Body: {
                                  style: {
                                    zIndex: 100,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  }}
                  numPages={data?.meta.lastPage || 0}
                  currentPage={page}
                  onPageChange={({ nextPage }) => {
                    setPage(
                      Math.min(Math.max(nextPage, 1), data?.meta.lastPage),
                    );
                  }}
                />
              </DrawerFooter>
            )}
          </>
        )}
      </DrawerBody>
    </>
  );
}
